<div class="alert-panel-container">
  <div class="d-flex align-items-center justify-content-between mb-3">
    <h5 class="alert-panel-title">Alerts</h5>
    <button class="btn btn-link alert-notification" (click)="toggleAlertSound()" style="color: #fff">
      @if (isAlertChimeOn()) {
      <span title="alert sound on">
        <i class="fa fa-bell fa-lg" aria-hidden="true"></i>
      </span>
      }
      @if (!isAlertChimeOn()) {
      <span title="alert sound off">
        <i class="fa fa-bell-slash fa-lg" aria-hidden="true"></i>
      </span>
      }
    </button>
  </div>
  <div class="d-flex gap-2 mb-3">
    <select class="form-select" style="border-radius: 4px">
      <option selected disabled>All</option>
    </select>
    <select class="form-select" style="border-radius: 4px" id="statusSelect" [(ngModel)]="statusFilterName"
      (ngModelChange)="onStatusFilterChange($event)">
      @for (status of statusOptions; track status) {
      <option [value]="status">
        {{ status }}
      </option>
      }

    </select>
  </div>
  <div class="custom-scroll">
    @if (statusFilterName === 'Dismissed') {
    <div style="border: solid 1px #fff; border-radius: 5px;">
      <table style="width: 100%; background-color: rgba(0,0,0,0)">
        <tr>
          <td>
            <span class="fs-6 text-white">Page {{dismissedAlertPage}}</span>
          </td>
          <td>
            <i class="fa fa-caret-left fa-1x text-white" (click)="onDismissedAlertPageChange(-1)"
              [class.disabled]="dismissedAlertPage <= 1" style="cursor: pointer" title="previous page"></i>
          </td>
          <td>
            <i class="fa fa-caret-right fa-1x text-white" (click)="onDismissedAlertPageChange(1)"
              [class.disabled]="dismissedAlertsList.length < 25" style="cursor: pointer" title="next page"></i>
          </td>
          <td>
            <input type="text" placeholder="keyword" [(ngModel)]="alertSearchKeyword"
              (keyup)="onDismissedAlertSearchKeyup($event)">
          </td>
          <td>
            <i class="fa fa-search fa-1x text-white" (click)="onDismissedAlertSearch()" style="cursor: pointer"
              title="search in alert title"></i>
          </td>
        </tr>
      </table>
    </div>
    }

    @if (statusFilterName === 'Dismissed' && dismissedAlertsList.length === 0 && !isLoadingDismissed) {
    <div class="fs-6 text-white text-center">
      No Alerts Found
    </div>
    }

    @if (statusFilterName === 'Dismissed') {
    <div>
      @for (noti of dismissedAlertsList; track trackById($index, noti)) {
      <div>
        <div class="alert-outer" [id]="noti.id">
          <div [id]="noti.id" class="notificationHero notification-fadein red-bg" (click)="runAlert($event, noti)">
            <div class="alert-row">
              <div class="alert-column-left">
                <div class="alert-headerLeft">
                  <span class="alert-icon">
                    <i class="fa fa-exclamation-triangle"></i> </span>
                </div>
              </div>
              <div class="alert-column-right">
                <div class="alert-title-head">
                  <h6>{{ noti.name }}</h6>
                  <div class="alert-indicator">
                    @if (noti.alertRead) {
                    <i class="fa fa-circle" title="read"></i>
                    } @if (!noti.alertRead) {
                    <i class="fa fa-circle-o" title="not read"></i>
                    }
                  </div>
                </div>
                @for (building of noti.buildingInfo; track $index) {
                <div class="alert-builing-info px-0">
                  <div [title]="'Building: ' + (building.building?.label || '')">
                    B:
                    <span style="color: #fff">{{
                      building.building?.label?.slice(0, 18)
                      }}</span>
                  </div>
                  <div [title]="'Floor: ' + (building.floor?.label || '')">
                    F:
                    <span style="color: #fff">{{
                      building.floor?.label?.slice(0, 1)
                      }}</span>
                  </div>
                  <div [title]="'Room: ' + (building.room?.label || '')">
                    &nbsp; R:
                    <span style="color: #fff">{{
                      building.room?.label?.slice(0, 10)
                      }}</span>
                  </div>
                </div>
                }
                <div class="alert-builing-info px-0">
                  <span>{{ noti.createdAt | date : "MM/dd/yyyy HH:mm:ss" }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
    }
    @if (statusFilterName !== 'Dismissed') {
    <div>
      @for (noti of notificationsList; track noti.id; let i = $index) {
      <div class="alert-outer" [id]="noti.id">
        <div [id]="noti.id" class="notificationHero {{ noti.alertBeingRead }} notification-fadein white-bg"
          (click)="runAlert($event, noti)">
          <div class="alert-row">
            <div class="alert-column-left">
              <div class="alert-headerLeft">
                <span class="alert-icon">
                  <i class="fa fa-exclamation-triangle"></i> </span>
              </div>
            </div>
            <div class="alert-column-right">
              <div class="alert-title-head">
                <h6>{{ noti.name }}</h6>
                <div class="alert-indicator">
                  @if (noti.alertRead) {
                  <i class="fa fa-circle" title="read"></i>
                  } @if (!noti.alertRead) {
                  <i class="fa fa-circle-o" title="not read"></i>
                  }
                </div>
              </div>
              @for (building of noti.buildingInfo; track $index) {
              <div class="alert-builing-info px-0">
                <div [title]="'Building: ' + (building.building?.label || '')">
                  B:
                  <span style="color: #fff">{{
                    building.building?.label?.slice(0, 18)
                    }}</span>
                </div>
                <div [title]="'Floor: ' + (building.floor?.label || '')">
                  F:
                  <span style="color: #fff">{{
                    building.floor?.label?.slice(0, 1)
                    }}</span>
                </div>
                <div [title]="'Room: ' + (building.room?.label || '')">
                  &nbsp; R:
                  <span style="color: #fff">{{
                    building.room?.label?.slice(0, 10)
                    }}</span>
                </div>
              </div>
              }
              <div class="alert-builing-info px-0">
                <span>{{ noti.createdAt | date : "MM/dd/yyyy HH:mm:ss" }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
    }
  </div>
</div>